export const environment = {
  mode: 'staging',
  production: true,
  hmr: false,
  apiUrl: 'https://stagingserver.mrpro.cloud',
  debugTranslation: false,
  baseheader: 'TVIucHJvX0Jhc2VfMjAyNl9BZG1pbjpFVi5yOUghYjQzbT4xeCl0UD46a3VjV0RVN3BjOS4=',
  okta: {
    redirectUri: 'https://staging.mrpro.cloud/login/callback',
    logoutUri: 'https://staging.mrpro.cloud/',
    clientId: '0oacbgbmmwKUoXtwt0i7',
    domain: 'login.vossloh-digital.com',
    showLogin: true,
  },
  msalConfig: {
    redirectUri: 'https://staging.mrpro.cloud/login',
    showLogin: true,
  },
  apiConfig: {
    scopes: ['ENTER_SCOPE'],
    uri: 'ENTER_URI',
  },
};
